import { Link, useNavigate } from 'react-router-dom';
import { Fragment } from 'react/jsx-runtime';
import { TBreadcrumbProps } from '@/types';
import { ArrowLeft } from 'lucide-react';
import routes from '@/lib/routes';
import { cn } from '@/lib/utils';
import {
  BreadcrumbSeparator,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuItem,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  DropdownMenu,
  Breadcrumb,
  Button
} from '@/components/ui';

const BreadcrumbsPage = ({ title, subMenus }: TBreadcrumbProps) => {

  const navigate = useNavigate();

  const handleOnClickBtnGoBack = () =>
    navigate(-1);

  return (
    <div className='flex items-center space-x-3'>
      <Button
        className='h-0 w-auto'
        title='Retourner à la page précédente'
        onClick={handleOnClickBtnGoBack}
        variant={'ghost'}
        size={'icon'}>
        <ArrowLeft size={20} />
      </Button>
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink title={`Page d'acceuil`}>
              <Link replace to={routes.nav.home}>
                Acceuil
              </Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          {
            title &&
            <>
              <BreadcrumbSeparator />
              {
                subMenus
                  ?.map(
                    subMenu => (
                      <Fragment key={subMenu.title}>
                        {
                          !subMenu.menus &&
                          <BreadcrumbLink
                            className={subMenu.className}
                            title={subMenu.tooltip}>
                            <Link replace to={subMenu.href}>
                              {subMenu.title}
                            </Link>
                          </BreadcrumbLink>
                        }
                        {
                          subMenu.menus &&
                          <BreadcrumbItem>
                            <DropdownMenu>
                              <DropdownMenuTrigger
                                className={subMenu.className}
                                title={subMenu.tooltip}>
                                {subMenu.title}
                              </DropdownMenuTrigger>
                              <DropdownMenuContent align='start'>
                                {
                                  subMenu
                                    .menus
                                    .map(
                                      menu => (
                                        <DropdownMenuItem
                                          key={menu.href.toString()}
                                          title={menu.tooltip}
                                          onClick={() => navigate(menu.href, { replace: true })}
                                          className={cn(
                                            'cursor-pointer text-sm hover:text-purple-600',
                                            menu.className
                                          )}>
                                          {menu.title}
                                        </DropdownMenuItem>
                                      )
                                    )
                                }
                              </DropdownMenuContent>
                            </DropdownMenu>
                          </BreadcrumbItem>
                        }
                        <BreadcrumbSeparator />
                      </Fragment>
                    )
                  )
              }
              <BreadcrumbItem>
                <BreadcrumbPage className='text-purple-600'>
                  {title}
                </BreadcrumbPage>
              </BreadcrumbItem>
            </>
          }
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  );

};

export default BreadcrumbsPage;
